import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import ThemeToggle from "./ThemeToggle";
import { Button } from "./ui/button";

const navLinks = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/projects", label: "Projects" },
];

export default function AppHeader() {
  const { currentUser, signOut, isAdmin } = useAuth();
  const location = useLocation();

  const adminLinks = isAdmin ? [
    { to: "/users", label: "Users" },
    { to: "/smtp-configuration", label: "SMTP" },
  ] : [];
  const allLinks = [...navLinks, ...adminLinks];

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <header className="border-b border-primary-200 dark:border-primary-800 bg-white dark:bg-primary-900">
      <div className="container-elegant py-4 sm:py-6 flex justify-between items-center gap-4">
        <Link
          to="/dashboard"
          className="text-xl sm:text-2xl font-light tracking-tight text-primary-950 dark:text-white hover:opacity-80 transition-opacity"
        >
          MARQ
        </Link>
        <nav className="hidden sm:flex items-center gap-6">
          {allLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm uppercase tracking-widest transition-colors ${
                isActive(link.to)
                  ? "text-primary-950 dark:text-white border-b border-primary-950 dark:border-white pb-0.5"
                  : "text-primary-600 dark:text-primary-400 hover:text-primary-950 dark:hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3 sm:gap-6 shrink-0">
          <span className="text-sm text-primary-600 dark:text-primary-400 truncate max-w-[120px] sm:max-w-none">
            {currentUser?.fullName}
          </span>
          <ThemeToggle />
          <Button
            variant="ghost"
            size="sm"
            onClick={() => signOut()}
            className="text-sm uppercase tracking-widest text-primary-600 dark:text-primary-400 hover:text-primary-950 dark:hover:text-white whitespace-nowrap"
          >
            Sair
          </Button>
        </div>
      </div>
    </header>
  );
}
